import * as React from "react";
import type { SVGProps } from "react";
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12.707 2.293 12 1.586 10.586 3l.707.707.302.302a9 9 0 0 0-6.97 14.15 1 1 0 1 0 1.637-1.148 7 7 0 0 1 5.31-10.998l-.28.28-.706.707L12 8.414l.707-.707 2-2a1 1 0 0 0 0-1.414zM21 13a1 1 0 1 0-2 0 7 7 0 0 1-10.09 6.283 1 1 0 0 0-.885 1.793A9 9 0 0 0 21 13"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgRefresh;
